import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Heading, HeadingSize, HeadingPriority } from '@as/cotopaxi';
import { useAvailabilityDescription } from '../hooks/useAvailabilityDescription';
const AvailabilityDescriptionContainer = ({ unavailableProduct, }) => {
    const { getKeyForText } = useAvailabilityDescription(unavailableProduct);
    if (!getKeyForText()) {
        return null;
    }
    return (_jsx(Box, { mobile: { spacing: { marginTop: 1 } }, children: _jsx(Heading, { size: HeadingSize.S, priority: HeadingPriority.H3, children: getKeyForText() }) }));
};
export default AvailabilityDescriptionContainer;
